import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 40px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      align-items: flex-start;
      gap: 24px;
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    color: ${theme.v2.colors.neutral.lowDark};
    margin: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }    
  `}
`;

export const ButtonWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 16px;
    text-wrap-mode: nowrap;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      gap: 12px;
      width: 100%;
    }
  `}
`;
